import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpdateMailingListsTargetQuantity } from './types/update-mailing-lists-target-quantity.type';

export const updateMailingListsTargetQuantity = async (
  instance: KyInstance,
  mailingId: number,
  lists: UpdateMailingListsTargetQuantity[]
) => {
  try {
    if (isNotDefined(mailingId)) {
      throw new Error('Mailing id is required for update.');
    }

    return await instance.put<OperationResult>(formatString(Uri.nth.update, mailingId.toString()), {
      json: lists,
    });
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
